import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL, SISTEMA_URL } from "../config";
import pdfIcon from '../assets/img/pdf-download-icon.png';
import axios from "axios";

function ReportDiario() {
    const [data, setData] = useState(null);
    const { id, hash } = useParams();

    const responsiveStyles = `
        .report-container {
            overflow-x: auto;
            width: 100%;
            -webkit-overflow-scrolling: touch;
        }
        
        @media screen and (max-width: 768px) {
            table {
                min-width: 100% !important;
            }
        
            table[width="600"], 
            table[style*="width: 600px"] {
                width: 100% !important;
            }
        
            span[style*="font-size: 26px"],
            .large-text {
                font-size: 20px !important;
            }
        
            span[style*="font-size: 14px"],
            .medium-text {
                font-size: 12px !important;
            }
        
            img {
                max-width: 100% !important;
                height: auto !important;
            }
        
            td[style*="padding: 15px"] {
                padding: 10px !important;
            }
        
            a[style*="font-weight:bold"] {
                display: inline-block;
                padding: 8px 12px;
            }
        }
        
        @media screen and (max-width: 480px) {
            span[style*="font-size: 26px"],
            .large-text {
                font-size: 18px !important;
            }
        
            span[style*="font-size: 14px"],
            .medium-text {
                font-size: 11px !important;
            }
        
            h1[style*="font-size: 20px"] {
                font-size: 16px !important;
                padding-left: 15px !important;
            }
        
            div[style*="margin:0 0 30px 70px"] {
                margin-left: 20px !important;
                margin-right: 10px !important;
            }
        
            a[style*="font-size: 36px"] {
                font-size: 24px !important;
                padding: 0 5px !important;
            }
        }
    `;

    const fetchData = async () => {
        try {
            const response = await axios.get(
                `${API_BASE_URL}/report-diario/${id}/${hash}`,
                {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );

            const originalHtml = response.data;
            let modifiedHtml = '';

            if (originalHtml.length > 0) {
                modifiedHtml = originalHtml.replace(
                    /(<td[^>]*align="center"[^>]*>)/i,
                    `$1
                        <div style="position: relative;">
                            <a href="${SISTEMA_URL}/newsletter/pdf/${id}/${hash}"
                                target="_blank"
                                style="
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    width: 40px;
                                    height: 40px;
                                    background-image: url('${pdfIcon}');
                                    background-size: contain;
                                    background-repeat: no-repeat;
                                    background-position: center;
                                    text-decoration: none;
                                    z-index: 999;
                                ">
                            </a>
                        </div>
                    `
                );
            }

            setData(modifiedHtml);
        } catch (error) {
            console.error("Error fetching data:", error);
            setData(null);
        }
    };

    useEffect(() => {
        const handleAnchorClick = (event) => {
            const anchor = event.target.closest('a[href^="#sumario_"]');
            if (anchor) {
                event.preventDefault();
                const targetName = anchor.getAttribute('href').substring(1);
                const targetElement = document.querySelector(`a[name="${targetName}"]`);

                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                }
            }
        };

        document.addEventListener('click', handleAnchorClick);

        return () => {
            document.removeEventListener('click', handleAnchorClick);
        };
    }, []);

    useEffect(() => {
        fetchData();
    }, [id, hash]);

    return (
        <div>
            <style>{responsiveStyles}</style>

            {data ? (
                <div dangerouslySetInnerHTML={{ __html: data }} />
            ) : (
                null
            )}
        </div>
    );
}

export default ReportDiario;